import { useStyleSheet } from '../../../hooks/useStyleSheet';

export const useStyles = () => {
  const styles = useStyleSheet(
    () => ({
      container: {
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        maxWidth: '100%',
        alignItems: 'center',
        height: '40px',
      },
      img: {
        width: '10rem',
        objectFit: 'contain',
      },
    }),
    [],
  );

  return styles;
};
